import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Font styles mixin
 */
@Component
export default class extends Vue {

  @Prop({ type: String })
  fontColor?: string

  @Prop({ type: String })
  fontFamily?: string

  @Prop({ type: String, default: '' })
  fontSize!: string

  @Prop({ type: [String, Number], default: '' })
  fontWeight!: string | number

  get computedFontStyles () {
    const {
      fontColor,
      fontFamily,
      fontSize,
      fontWeight,
    } = this
    return {
      color: fontColor,
      fontFamily,
      fontSize,
      fontWeight,
    }
  }
}
